<template>
	<div>
		<div v-if="smsSent" class="item-edit" style="animation-delay: 2s">
			<div class="mb-2">Bitte gib hier den Code ein:</div>
			<b-input
				v-model="mobilePhoneCode"
				ref="mobilePhoneCodeInput"
				class="w-auto"
				@keyup.enter="confirmMobilePhone"
			/>
			<div class="mt-4">
				<Button
					text="Code bestätigen"
					icon="checkmark"
					:loading="saving"
					:disabled="!mobilePhoneCodeValid || saving"
					@click="confirmMobilePhone"
				/>
			</div>
			<div class="mt-4">
				<div>Mobilnummer falsch?</div>
				<div>
					<a href="#" @click.prevent="changeData">Hier ändern</a>
				</div>
			</div>
			<div class="mt-4">
				<div>Keine SMS bekommen?</div>
				<div>
					<div v-if="smsSentAgain" class="success">Erfolgreich versendet</div>
					<a v-else-if="!saving" href="#" @click.prevent="save(true)">Hier nochmals senden</a>
				</div>
			</div>
		</div>
		<div v-else class="sections">
			<div v-if="checkData">
				<div class="color-primary font-weight-extra-bold">
					Bitte prüfe deine Angaben.<br/>
					Der Vor- und Nachname und das Geburtsdatum können nachträglich nicht mehr geändert werden.
				</div>
				<div class="mt-3">
					<div>
						<span class="font-weight-extra-bold">Vorname:</span>
						{{ personalData.firstName }}
					</div>
					<div>
						<span class="font-weight-extra-bold">Nachname:</span>
						{{ personalData.lastName }}
					</div>
					<div>
						<span class="font-weight-extra-bold">Geburtsdatum:</span>
						{{ personalData.dateOfBirth | dateByObject }}
					</div>
					<div v-if="mobilePhoneNumber">
						<span class="font-weight-extra-bold">Mobilnummer:</span>
						{{ mobilePhoneNumber | phone }}
					</div>
				</div>
				<div class="mt-3 text-right">
					<b-form-checkbox v-model="checkDataOk">Meine Daten stimmen</b-form-checkbox>
				</div>
			</div>
			<template v-else>
				<template v-if="mobilePhoneAndPersonalDataNecessary">
					<section>
						<div>
							<div class="font-weight-extra-bold">Sicherheits-Code anfordern:</div>
							<div class="mt-2">
								Um dein Konto zu schützen, wird eine Mobilnummer hinterlegt. Sollten auffällige
								Zugriffsversuche auf dein Profil erfolgen oder deine Zugangsdaten verloren gehen, wird
								dir über die Mobilnummer ein Sicherheitscode gesendet.
							</div>
							<ul class="content-list mt-3">
								<li>Deine Telefonnummer wird von skilldoo nicht an Dritte weitergegeben.</li>
								<li>skilldoo wird dich nicht über diese Telefonnummer anrufen.</li>
							</ul>
						</div>
						<Phone
							v-model="mobilePhoneNumber"
							:meta="meta"
							class="mt-4"
							:show-missing-error="false"
						/>
						<div class="mt-2">Es wird dir ein einmaliger Sicherheitscode zur Bestätigung übermittelt.</div>
						<div class="font-weight-bold mt-5">Geheime Kontodaten</div>
						<div>Persönliche Daten werden nur dann für einen Arbeitgeber sichtbar, wenn du sie ihm
							freigibst:
						</div>
						<b-row class="mt-4">
							<b-col md="2">
								<FormGroup>
									<SalutationSelect v-model="personalData.salutation"/>
								</FormGroup>
							</b-col>
							<b-col md="2" class="mt-2 mt-md-0">
								<b-input v-model="personalData.title" placeholder="Titel"/>
							</b-col>
							<b-col md="3" class="mt-2 mt-md-0">
								<FormGroup>
									<b-input v-model="personalData.firstName" placeholder="Vorname"/>
								</FormGroup>
							</b-col>
							<b-col md="3" class="mt-2 mt-md-0">
								<FormGroup>
									<b-input v-model="personalData.lastName" placeholder="Nachname"/>
								</FormGroup>
							</b-col>
							<b-col md="2" class="mt-2 mt-md-0">
								<b-input v-model="personalData.appendingTitle" placeholder="Titel nachgestellt"/>
							</b-col>
						</b-row>
						<div class="mt-4">
							<b-row>
								<b-col md="6">
									<FormGroup label="Staatsbürgerschaft(en)">
										<CountryAutocomplete
											v-model="personalData.citizenships"
											:meta="meta"
										/>
									</FormGroup>
								</b-col>
								<b-col md="6">
									<FormGroup label="Wann bist du geboren?" class="mt-3 mt-md-0">
										<DateInputs
											v-model="personalData.dateOfBirth"
											:show-incomplete-error="false"
										/>
									</FormGroup>
								</b-col>
							</b-row>
							<div v-if="showNameDateOfBirthWarning" class="font-weight-extra-bold">
								Achtung: Geburtsdatum sowie Vor- und Nachname können später nicht mehr geändert werden.
							</div>
						</div>
					</section>
				</template>
				<section v-if="domicileNecessary">
					<h3>Dein Wohnort</h3>
					<PostalCodeEdit
						v-model="domicile"
						:meta="meta"
						:coloring="false"
						with-country-selection
					/>
				</section>
			</template>
			<section class="legitimation--continue">
				<template v-if="checkData">
					<Button
						v-if="!saving"
						text="Daten ändern"
						secondary
						class="mr-3 mb-3 mb-md-0"
						icon="edit"
						@click="checkData = false"
					/>
				</template>
				<Button
					:text="checkData ? 'Bestätigen / SMS-Code anfordern' : 'Weiter'"
					icon="checkmark"
					:loading="saving"
					:disabled="saveButtonDisabled"
					@click="save(false)"
				/>
			</section>
		</div>
		<PopUp
			v-if="showInvalidFields"
			title="Ungültige Eingaben"
			ok-text="OK"
			hide-cancel
			@ok="showInvalidFields = false"
			@hidden="showInvalidFields = false"
		>
			<p>Bitte überprüfe die folgenden Felder:</p>
			<ul class="content-list">
				<li v-for="field in invalidFields" :key="field">{{ field }}</li>
			</ul>
		</PopUp>
	</div>
</template>

<script>
import CountryMultiSelect from "@/vue/common/form/CountryMultiSelect";
import Phone from "@/vue/common/form/Phone";
import {isDefined} from "@/helper/Value";
import {isEmptyOrNull} from "@/helper/String";
import PostalCodeEdit from "../common/postal-code/Edit";
import SalutationSelect from "@/vue/common/form/SalutationSelect";
import Button from "@/vue/common/Button";
import Save from "@/api/job/questionnaire/legitimation/Save";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import Change from "@/api/application/legitimation/Change";
import {MOBILE_PHONE} from "@/helper/application/legitimation/Type";
import _ from "lodash";
import CountryAutocomplete from "@/vue/common/form/CountryAutocomplete";
import {arrayIsNotEmpty} from "@/helper/Array";
import FormGroup from "@/vue/common/form/Group";
import DateOfBirth from "@/vue/application/DateOfBirth";
import DateInputs from "@/vue/common/form/DateInputs.vue";
import PopUp from "@/vue/common/PopUp";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";

export default {
	components: {
		DateInputs,
		DateOfBirth,
		CountryAutocomplete,
		Button,
		CountryMultiSelect,
		PostalCodeEdit,
		FormGroup,
		Phone,
		SalutationSelect,
		PopUp,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
		item: {
			type: Object,
			required: true,
		},
		job: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		let citizenships = undefined;

		if (this.item.payload.personalData.citizenships)
		{
			citizenships = _.map(this.item.payload.personalData.citizenships, 'country');
		}

		return {
			domicile: undefined,
			mobilePhoneNumber: undefined,
			mobilePhoneCode: '',
			personalData: {
				title: this.item.payload.personalData.title,
				firstName: this.item.payload.personalData.firstName,
				lastName: this.item.payload.personalData.lastName,
				appendingTitle: this.item.payload.personalData.appendingTitle,
				salutation: this.item.payload.personalData.salutation,
				citizenships,
				dateOfBirth: this.item.payload.personalData.dateOfBirth,
			},
			checkData: false,
			checkDataOk: false,
			smsSent: false,
			smsSentAgain: false,
			showInvalidFields: false,
			saving: false
		};
	},

	computed: {
		showNameDateOfBirthWarning ()
		{
			return !isEmptyOrNull(this.personalData.firstName)
				&& !isEmptyOrNull(this.personalData.lastName)
				&& isDefined(this.personalData.dateOfBirth);
		},
		saveButtonDisabled ()
		{
			if (this.saving)
			{
				return true;
			}

			if (!this.checkData)
			{
				return false;
			}

			return !this.checkDataOk;
		},
		mobilePhoneAndPersonalDataNecessary ()
		{
			return this.item.payload.mobilePhoneAndPersonalDataNecessary;
		},
		domicileNecessary ()
		{
			return this.item.payload.domicileNecessary;
		},
		salutationValid ()
		{
			return isDefined(this.personalData.salutation);
		},
		firstNameValid ()
		{
			return !isEmptyOrNull(this.personalData.firstName);
		},
		lastNameValid ()
		{
			return !isEmptyOrNull(this.personalData.lastName);
		},
		dateOfBirthValid ()
		{
			return isDefined(this.personalData.dateOfBirth);
		},
		citizenshipsValid ()
		{
			return arrayIsNotEmpty(this.personalData.citizenships);
		},
		mobilePhoneValid ()
		{
			return !this.mobilePhoneAndPersonalDataNecessary || isDefined(this.mobilePhoneNumber);
		},
		personalDataValid ()
		{
			if (!this.mobilePhoneAndPersonalDataNecessary)
			{
				return true;
			}

			return this.salutationValid
				&& this.firstNameValid
				&& this.lastNameValid
				&& this.dateOfBirthValid
				&& this.citizenshipsValid;
		},
		domicileValid ()
		{
			return !this.domicileNecessary || isDefined(this.domicile);
		},
		checkDataValid ()
		{
			return !this.checkData || this.checkDataOk;
		},
		invalidFields ()
		{
			let fields = [];

			if (!this.mobilePhoneValid)
			{
				fields.push('Mobil-Nummer');
			}

			if (!this.salutationValid)
			{
				fields.push('Anrede');
			}

			if (!this.firstNameValid)
			{
				fields.push('Vorname');
			}

			if (!this.lastNameValid)
			{
				fields.push('Nachname');
			}

			if (!this.citizenshipsValid)
			{
				fields.push('Staatsbürgerschaft(en)');
			}

			if (!this.dateOfBirthValid)
			{
				fields.push('Geburtsdatum');
			}

			if (!this.domicileValid)
			{
				fields.push('Wohnort');
			}

			return fields;
		},
		dataValid ()
		{
			return this.mobilePhoneValid
				&& this.personalDataValid
				&& this.domicileValid
				&& this.checkDataValid;
		},
		mobilePhoneCodeValid ()
		{
			return !isEmptyOrNull(this.mobilePhoneCode);
		}
	},

	methods: {
		changeData ()
		{
			this.smsSent = false;

			this.$emit('revertMobilePhoneConfirmation');
		},
		async save (again)
		{
			if (!this.checkData && !this.dataValid && !again)
			{
				this.showInvalidFields = true;
				return;
			}

			if (!this.checkData && !again)
			{
				Event.push(
					new EventData()
						.setEvent(Event.QUESTIONNAIRE)
						.setAction('Sicherheitscode Selbstprüfungs-Seite')
				);

				this.checkData = true;
				return;
			}

			Event.push(
				new EventData()
					.setEvent(Event.QUESTIONNAIRE)
					.setAction(again ? 'Sicherheitscode erneut angefordert' : 'Sicherheitscode Daten bestätigt')
			);

			this.saving = true;

			const save = new Save()
				.setJobId(this.job.id);

			if (this.mobilePhoneAndPersonalDataNecessary)
			{
				let personalData = _.cloneDeep(this.personalData);

				personalData.citizenships = _.map(personalData.citizenships, 'id');

				save
					.setMobilePhoneNumber(this.mobilePhoneNumber)
					.setPersonalData(personalData);
			}

			if (this.domicileNecessary)
			{
				let domicile = undefined;

				if (this.domicileNecessary)
				{
					domicile = _.cloneDeep(this.domicile);

					if (domicile.postalCodes)
					{
						domicile.postalCode = _.first(domicile.postalCodes).id;

						delete domicile.postalCodes;
					}
				}

				save.setDomicile(domicile);
			}

			try
			{
				await save.call();

				if (this.mobilePhoneAndPersonalDataNecessary)
				{
					this.mobilePhoneCode = '';
					this.smsSent = true;
					this.checkData = false;
					this.checkDataOk = false;
					this.saving = false;

					if (again)
					{
						this.smsSentAgain = true;

						window.setTimeout(() => this.smsSentAgain = false, 3000);
					}

					this.$emit('mustConfirmMobilePhone', {
						mobilePhoneNumber: this.mobilePhoneNumber,
					});

					this.$nextTick(() =>
					{
						if (this.$refs.mobilePhoneCodeInput)
						{
							this.$refs.mobilePhoneCodeInput.focus();
						}
					});

					return;
				}

				this.$emit('finish');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.saving = false;
		},
		async confirmMobilePhone ()
		{
			if (!this.mobilePhoneCodeValid)
			{
				return;
			}

			this.saving = true;

			try
			{
				const response = await new Change()
					.setType(MOBILE_PHONE)
					.setCode(this.mobilePhoneCode)
					.setPublishJobIfPossible(this.job.id)
					.call();

				Event.push(
					new EventData()
						.setEvent(Event.QUESTIONNAIRE)
						.setAction('Sicherheitscode eingegeben')
				);

				this.$emit('finish', {
					publishedJob: response.data.publishedJob || false
				});
			}
			catch (e)
			{
				Toast.error(this, ['Der eingegebene Code ist nicht korrekt.']);
			}

			this.saving = false;
		}
	}
}
</script>
